
export interface City  {
    name:string;
    alias:string;
}
